import { useConversationUpdate } from 'app/reviewManagement/messaging/hooks/useConversationUpdate';
import { useReviewListWebsocket } from 'app/reviewManagement/reviewList/hooks/useReviewListWebsocket';

export const useRealtimeUpdates = () => {
    useConversationUpdate();
    useReviewListWebsocket();
};
